import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

const API_HOST = process.env.VUE_APP_API_HOST || 'https://api.cryppay.net'

const adminHttp = axios.create({
  baseURL: API_HOST + '/admin',
  timeout: 15000
})

function setupInterceptors(instance, tokenKey, loginPath) {
  instance.interceptors.request.use((config) => {
    const token = sessionStorage.getItem(tokenKey)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })

  instance.interceptors.response.use(
    (res) => {
      const data = res.data
      if (data.code === 401) {
        sessionStorage.removeItem(tokenKey)
        Message.error(data.msg || '登录已过期')
        router.replace(loginPath)
        return Promise.reject(data)
      }
      if (data.code !== 0 && data.code !== undefined) {
        Message.error(data.msg || '请求失败')
        return Promise.reject(data)
      }
      return data
    },
    (err) => {
      if (err.response && err.response.status === 401) {
        sessionStorage.removeItem(tokenKey)
        router.replace(loginPath)
      }
      Message.error(err.message || '网络错误')
      return Promise.reject(err)
    }
  )
}

setupInterceptors(adminHttp, 'cryptopay_admin_token', '/login')

export { adminHttp }
